<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary' | 'tertiary'
    size?: 'sm' | 'md' | 'lg'
    disabled?: boolean
    type?: 'button' | 'submit' | 'reset'
  }>(),
  {
    variant: 'primary',
    size: 'md',
    type: 'button',
  },
)

const variantClass = computed(() => {
  const map = {
    primary: 'bg-primary-container text-white hover:brightness-110 active:brightness-90 rounded',
    secondary: 'bg-surface-container-high text-on-surface hover:bg-surface-container-highest border border-border rounded',
    tertiary: 'text-primary hover:text-on-surface bg-transparent',
  }
  return map[props.variant]
})

const sizeClass = computed(() => {
  const map = {
    sm: 'text-[0.65rem] px-4 py-1',
    md: 'text-[0.7rem] px-6 py-1.5',
    lg: 'text-sm px-8 py-2',
  }
  return map[props.size]
})
</script>

<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="[
      'inline-flex items-center justify-center gap-2 font-mono uppercase tracking-widest font-bold',
      'disabled:opacity-40 disabled:cursor-not-allowed',
      variantClass,
      sizeClass,
    ]"
  >
    <slot />
  </button>
</template>
